import {post} from '@/utils/request';
import{erpserver} from '@/utils/baseUrl';

//查询列表
export async function getApiLogList(params) {
    return post(erpserver+'/log/getApiLogList', params, true)
}
export async function getMqDetail(params) {
    return post(erpserver+'/log/getMqDetail', params, true)
}
export async function retry(params) {
    return post(erpserver+'/log/retry', params, true)
}
//对接系统,接口
export async function getExternalSystem(params) {
    return post(erpserver+'/log/getExternalSystem', params, true)
}
//接口
export async function getInterfaceList(params) {
    return post(erpserver+'/log/getInterfaceList', params, true)
}

//接口
export async function getApiCallDirection(params) {
    return post(erpserver+'/log/getApiCallDirection', params, true)
}
